
<div>
  <page-header>
    <div class="row ml-3">
      <div class="ml-1">
        <router-link class="ml-4 mt-3 mb-2" :to="{ name: 'Boards' }">
          <div class="badgebutton active text-nowrap c-white">
            <i class="far fa-clock"></i>
            Back to Landing page
          </div>
        </router-link>
      </div>
    </div>
  </page-header>

  <div class="so-overview">
    <SpecialOccurrencesOverview />
  </div>

  <AppInfo />
</div>
